import {
  eventEmitterDefaultLogger,
  EventEmitterWithLogger,
} from '@surglogs/eventemitter'

import {
  type IAuthContextStore,
  AuthContextStoreEvent,
  type AuthContextStoreEventData,
} from '@surglogs-app/types'

export class AuthContextStore
  extends EventEmitterWithLogger<AuthContextStoreEvent>
  implements IAuthContextStore
{
  protected logger = eventEmitterDefaultLogger

  protected logPrefix = 'AuthContextStore'

  private data: AuthContextStoreEventData = {
    userId: null,
    sessionId: null,
  }

  setUserId(userId: number | string | null) {
    if (this.data.userId !== Number(userId)) {
      this.data = {
        ...this.data,
        userId: Number(userId),
      }
      this.emit(AuthContextStoreEvent.UPDATED, this.data)
    }
    return this
  }

  getUserId() {
    return this.data.userId
  }

  getData() {
    return this.data
  }

  onChange(listener: (data: AuthContextStoreEventData) => void): () => void {
    this.on(AuthContextStoreEvent.UPDATED, listener)
    return () => {
      this.removeListener(AuthContextStoreEvent.UPDATED, listener)
    }
  }

  clearUserId() {
    this.data = { ...this.data, userId: null }
    this.emit(AuthContextStoreEvent.UPDATED, this.data)
    return this
  }

  getSessionId() {
    return this.data.sessionId
  }

  setSessionId(sessionId: string) {
    this.data = { ...this.data, sessionId }

    return this
  }
}
